import { HelpCircle } from "lucide-react";
import React, { useState } from "react";

const InfoTooltip = ({ message, className }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <span
            className={`relative cursor-pointer ${className}`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <HelpCircle className="!w-4 !h-4 mb-1" />
            {showTooltip && (
                <div className="absolute left-[-18px] !top-6 w-[200px] rounded-[8px] bg-[#19183A] !p-2 text-xs text-white z-10">
                    <p className="text-center">{message}</p>
                </div>
            )}
        </span>
    );
};

export default InfoTooltip;
